import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../../../utils';

export const FilterChipTriggerSelection = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <p
      className={cn(
        'border-l px-2.5 py-1.5 text-xs cursor-pointer grow overflow-hidden text-ellipsis',
        className,
      )}
      {...props}
      ref={ref}
    >
      {children}
    </p>
  );
});
